import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
import { Card, Money } from '@clari/ui'
import { bankingApi } from '@/lib/banking-api'

function fmtDate(iso: string | null, locale: string): string {
  return iso ? new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(iso)) : '—'
}

export function TransactionDetail() {
  const { t, i18n } = useTranslation('banking')
  const { id = '' } = useParams()
  const q = useQuery({
    queryKey: ['tx-detail', id],
    queryFn: () => bankingApi.getTransaction(id),
    enabled: Boolean(id),
  })
  const tx = q.data?.transaction

  return (
    <div className="mx-auto flex max-w-xl flex-col gap-4">
      <Link to="/app/transactions" className="text-sm text-text-muted hover:text-text">
        {t('transfer.back')}
      </Link>
      {q.isLoading ? <p className="text-text-muted">{t('common.loading')}</p> : null}
      {tx ? (
        <Card>
          <Money
            className="text-2xl"
            amountCents={tx.amount_cents}
            currency={tx.currency}
            locale={i18n.language}
            showSign
          />
          <dl className="mt-4 grid grid-cols-3 gap-y-3 text-sm">
            <dt className="text-text-muted">{t('transactions.filter_type')}</dt>
            <dd className="col-span-2">{t(`transactions.type.${tx.type}`, { defaultValue: tx.type })}</dd>
            <dt className="text-text-muted">{t('transactions.filter_status')}</dt>
            <dd className="col-span-2">{t(`transactions.status_${tx.status}`, { defaultValue: tx.status })}</dd>
            {tx.counterparty_name ? (
              <>
                <dt className="text-text-muted">{t('transactions.counterparty')}</dt>
                <dd className="col-span-2">{tx.counterparty_name}</dd>
              </>
            ) : null}
            {tx.reference ? (
              <>
                <dt className="text-text-muted">{t('transactions.reference')}</dt>
                <dd className="col-span-2">{tx.reference}</dd>
              </>
            ) : null}
            <dt className="text-text-muted">{t('transactions.date')}</dt>
            <dd className="col-span-2">{fmtDate(tx.booked_at ?? tx.created_at, i18n.language)}</dd>
          </dl>
        </Card>
      ) : null}
    </div>
  )
}
